import React from 'react'

import type { IconType } from 'react-icons'
import { twMerge } from 'tailwind-merge'

interface IconProps {
  icon: IconType
  size?: number
  variant?:
    | 'blue'
    | 'green'
    | 'red'
    | 'yellow'
    | 'purple'
    | 'orange'
    | 'gray'
    | 'pink'
}

export const Icon: React.FC<IconProps> = ({
  icon: Icon,
  variant = 'blue',
  size = 20,
}) => {
  let className = ''
  switch (variant) {
    case 'blue':
      className =
        'bg-blue-100 dark:bg-blue-700 text-blue-600 dark:text-blue-100'
      break
    case 'green':
      className =
        'bg-green-100 dark:bg-green-700 text-green-600 dark:text-green-100'
      break
    case 'red':
      className = 'bg-red-100 dark:bg-red-700 text-red-600 dark:text-red-100'
      break
    case 'yellow':
      className =
        'bg-yellow-100 dark:bg-yellow-600 text-yellow-600 dark:text-yellow-100'
      break
    case 'purple':
      className =
        'bg-purple-100 dark:bg-purple-700 text-purple-600 dark:text-purple-100'
      break
    case 'orange':
      className =
        'bg-orange-100 dark:bg-orange-600 text-orange-600 dark:text-orange-100'
      break
    case 'gray':
      className =
        'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-100'
      break
    case 'pink':
      className =
        'bg-pink-100 dark:bg-pink-700 text-pink-600 dark:text-pink-100'
      break
  }
  return (
    <div className={twMerge(className, 'p-[6px] rounded-[5px]')}>
      <Icon size={size} />
    </div>
  )
}

Icon.displayName = 'Home.Icon'
